import { isEmpty } from '@sgme/fp';
import { HStack, VStack } from '@sgme/ui';

import { InputGroup1 } from '@/App/tiles/TargetAccumulator/InputGroup1';
import { InputGroup2 } from '@/App/tiles/TargetAccumulator/InputGroup2';
import { InputGroup3 } from '@/App/tiles/TargetAccumulator/InputGroup3';
import { InputGroup4 } from '@/App/tiles/TargetAccumulator/InputGroup4';
import RightColumnHeader from '@/App/tiles/TargetAccumulator/RightColumnHeader.tsx';
import { NoSchedule } from '@/App/tiles/TargetAccumulator/Schedule/NoSchedule';
import ScheduleHeader from '@/App/tiles/TargetAccumulator/Schedule/ScheduleHeader';
import SchedulerTable from '@/App/tiles/TargetAccumulator/Schedule/SchedulerTable';
import { useTargetAccumulatorSelector } from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';

const ZoomedTileSchedulerView = () => {
  const hasSchedule = useTargetAccumulatorSelector(
    (targetAccumulator) => !isEmpty(targetAccumulator.properties.scheduleIds),
  );

  return (
    <VStack flex="expand" verticalAlignment="start" className="align-self-stretch">
      <RightColumnHeader />
      <HStack flex="expand" verticalAlignment="start" gap="4px" horizontalAlignment="start">
        <VStack className="m-8px p-8px border">
          <span className="active ms-16px mb-8px">Schedule parameters</span>
          <VStack>
            <VStack className="p-4px">
              <div>
                <InputGroup1 />
              </div>

              <div className="mt-3">
                <InputGroup2 />
              </div>
            </VStack>

            <VStack verticalAlignment="start">
              <div className="mt-3">
                <InputGroup3 />
              </div>
              <div className="mt-3">
                <InputGroup4 />
              </div>
            </VStack>
          </VStack>
        </VStack>
        {hasSchedule ? (
          <VStack className="border m-2 h-100">
            <ScheduleHeader />
            <SchedulerTable />
          </VStack>
        ) : (
          <div className="border m-2 p-2 w-100 h-75">
            <NoSchedule />
          </div>
        )}
      </HStack>
    </VStack>
  );
};

export default ZoomedTileSchedulerView;
